import { QueryClient, provideTanStackQuery } from '@tanstack/angular-query-experimental';
import { withDevtools } from '@tanstack/angular-query-experimental/devtools/production';

import { setContractsStrict } from './parse-response';

type ProvideIntegrationsParameters = {
    withQueryDevtools?: boolean;
    /**
     * When true, contract mismatches throw instead of being reported to Sentry and
     * passed through. Off by default (the rollout default) so a wrong schema can
     * never break prod. Apps typically opt in for non-prod, e.g. `strict: !isProd`.
     */
    strict?: boolean;
};
export function provideIntegrations({ withQueryDevtools = false, strict = false }: ProvideIntegrationsParameters = {}) {
    setContractsStrict(strict);

    return provideTanStackQuery(
        new QueryClient({
            defaultOptions: {
                queries: {
                    staleTime: 5 * 60 * 1000,
                    refetchOnWindowFocus: false,
                },
            },
        }),
        ...(withQueryDevtools ? [withDevtools(() => ({ loadDevtools: true, buttonPosition: 'bottom-left' }))] : [])
    );
}
